(
    function (skyward, $, undefined)
    {
        skyward.endorsements = skyward.endorsements || {};

        var init = function (selector)
        {
            if ($(selector).find("#EndorsementControlsDiv").length)
            {
                $(selector).find("select.EndorsementSelectClassname").on("change", function ()
                {
                    EndorsementControlChanged($(this).parents("#EndorsementControlsDiv"));
                });
                $(selector).find("select.EndorsementOptionSelectClassname").on("change", function ()
                {
                    EndorsementOptionControlChanged($(this).parents("#EndorsementControlsDiv"));
                });
            }

            if ($(selector).find(".endorsementProgressOptionDescriptionClassname").length)
            {
                $(selector).find(".endorsementProgressOptionDescriptionClassname").off("click", ShowEndorsementOptionDescriptionDialog).on("click", ShowEndorsementOptionDescriptionDialog);
            }

            RegisterContainers(selector);
        };

        var ShowEndorsementOptionDescriptionDialog = function ()
        {
            var button = $(this);
            var accessType = button.data("viewmode");
            var scopeType = button.data("scopetype");

            var buttonID = button.attr('id').split("-")[1];
            var primaryKey = -1;

            if (buttonID.length)
            {
                primaryKey = buttonID;
            }

            var dataParams =
            {
                    primaryKey: primaryKey,
                    scopeType: scopeType
            };

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "GraduationRequirements/StudentEndorsement/BuildEndorsementOptionDescriptionPopup" + accessType + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: dataParams
                })
            }

            var beforeClose = function ()
            {
                button.off().on('click', ShowEndorsementOptionDescriptionDialog);
            };

            button.off('click', ShowEndorsementOptionDescriptionDialog);

            skyward.modalLayer.showDialog("Endorsement Option", buildPopup, { text: "Close", icon: "Check" }, { anchorTo: button, beforeClose: beforeClose });
        }

        var RegisterContainers = function (selector)
        {
            if ($(selector).find("#EndorsementRequirementsWrapperDiv").length > 0)
            {
                var allDateChanges = $('.endorsementProgressCommonContainer');
                for (var i = 0; i < allDateChanges.length; i++)
                {
                    var dateChangePanel = $(allDateChanges[i]);
                    if (dateChangePanel.find('.endorsementProgressCommonButtonDiv'))
                    {
                        dateChangePanel.buttonDiv = dateChangePanel.find('.endorsementProgressCommonButtonDiv');
                        dateChangePanel.buttonDiv.click(function ()
                        {
                            ExpandCollapse();
                        });
                    }
                }

                var subChecklistGroupDateChanges = $('.endorsementProgressSubChecklistGroupContainer');
                for (var i = 0; i < subChecklistGroupDateChanges.length; i++)
                {
                    var dateChangePanel = $(subChecklistGroupDateChanges[i]);
                    if (dateChangePanel.find('.endorsementProgressSubChecklistGroupButtonDiv'))
                    {
                        dateChangePanel.buttonDiv = dateChangePanel.find('.endorsementProgressSubChecklistGroupButtonDiv');
                        dateChangePanel.buttonDiv.click(function ()
                        {
                            ExpandCollapse();
                        });
                    }
                }
            }
        }

        var ExpandCollapse = function ()
        {
            var target = $(event.target);
            var wrapper = target.parents('.endorsementProgressSubChecklistGroupButtonDiv').length > 0 ? target.closest('.endorsementProgressSubChecklistGroupContainer').find('div.endorsementProgressSubChecklistGroupBrowseFieldset') : target.closest('.endorsementProgressCommonContainer').find('div.endorsementProgressCommonBrowseFieldset');
            var isHidden = wrapper.hasClass('collapsed');

            if (isHidden)
            {
                var expandButton = target.closest('#expandButton');
                var collapseButton = $(expandButton).siblings('#collapseButton');
                wrapper.show();
                wrapper.removeClass("collapsed");
                wrapper.addClass("expanded");
                expandButton.hide();
                collapseButton.show();
            }
            else
            {
                var collapseButton = target.closest('#collapseButton');
                var expandButton = $(collapseButton).siblings('#expandButton');
                wrapper.hide();
                wrapper.removeClass("expanded");
                wrapper.addClass("collapsed");
                expandButton.show();
                collapseButton.hide();
            }
        }

        var EndorsementControlChanged = function (parentDiv)
        {
            var parentContainer = $(parentDiv);

            var endorsementSelectControl = parentContainer.find("select.EndorsementSelectClassname");
            var endorsementSelectControlValue = skyward.controls.getValue(endorsementSelectControl);

            var endorsementOptionSelectControl = parentContainer.find("select.EndorsementOptionSelectClassname");

            var jsonString = skyward.controls.getValue(parentContainer.find("#EndorsementDict"));

            var jsonDict = JSON.parse(jsonString);

            var studentID = skyward.controls.getValue(parentContainer.find("#StudentID"));
            var accessType = skyward.controls.getValue(parentContainer.find("#AccessType"));

            if (endorsementSelectControlValue in jsonDict)
            {
                var endorsement = jsonDict[endorsementSelectControlValue];
                var endorsementDesc = endorsement.Description;

                var newSelectedEndorsementOptionID = "";
                var newSelectedEndorsementOptionDesc = "";                

                var optionKeys = Object.keys(endorsement.EndorsementOptions);                
                var orderedOptionKeys = Object.keys(endorsement.EndorsementOptionsByOrderNumber);

                if (optionKeys.length > 0 && orderedOptionKeys.length > 0)
                {
                    newSelectedEndorsementOptionID = endorsement.EndorsementOptionsByOrderNumber[1];
                    newSelectedEndorsementOptionDesc = endorsement.EndorsementOptions[newSelectedEndorsementOptionID];

                    endorsementOptionSelectControl.empty();

                    for (key in endorsement.EndorsementOptionsByOrderNumber)
                    {
                        var realKey = endorsement.EndorsementOptionsByOrderNumber[key];
                        endorsementOptionSelectControl.append($('<option></option>').attr("value", realKey).attr("classname", "option ").text(endorsement.EndorsementOptions[realKey]));
                    }
                    skyward.controls.setValue(endorsementOptionSelectControl, newSelectedEndorsementOptionID);

                    RecalculateEndorsementProgress(studentID, endorsementSelectControlValue, newSelectedEndorsementOptionID, accessType, parentContainer);
                }
            }
        }

        var EndorsementOptionControlChanged = function (parentDiv)
        {
            var parentContainer = $(parentDiv);

            var endorsementSelectControl = parentContainer.find("select.EndorsementSelectClassname");
            var endorsementSelectControlValue = skyward.controls.getValue(endorsementSelectControl);

            var endorsementOptionSelectControl = parentContainer.find("select.EndorsementOptionSelectClassname");
            var endorsementOptionSelectControlValue = skyward.controls.getValue(endorsementOptionSelectControl);
            var studentID = skyward.controls.getValue(parentContainer.find("#StudentID"));
            var accessType = skyward.controls.getValue(parentContainer.find("#AccessType"));

            RecalculateEndorsementProgress(studentID, endorsementSelectControlValue, endorsementOptionSelectControlValue, accessType, parentContainer);
        }

        var RecalculateEndorsementProgress = function (studentID, selectedEndorsementID, selectedEndorsementOptionID, accessType, parentContainer)
        {
            var dataParams =
                {
                    studentID: studentID,
                    selectedEndorsementID: selectedEndorsementID,
                    selectedEndorsementOptionID: selectedEndorsementOptionID
                };

            $.ajax
                ({
                    url: skyward.global.virtualDir + "GraduationRequirements/StudentEndorsement/RecalculateEndorsementProgress" + accessType,
                    type: "POST",
                    dataType: "JSON",
                    data: dataParams,
                    success: function (returnData)
                    {
                        var updateHTML = returnData.Success;
                        if (updateHTML === true)
                        {
                            var viewPartHTML = returnData.ViewPartHTML;
                            parentContainer.siblings('#EndorsementRequirementsWrapperDiv').html(viewPartHTML);
                            skyward.window.notifyResize();
                            skyward.window.notifyDOMLoad("#EndorsementRequirementsWrapperDiv");
                            RegisterContainers(parentContainer.parent());
                        }
                    }
                });
        }        

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);